export const avatarString = (string: string) =>
    string
        .split(' ')
        .map((i) => i.charAt(0).toUpperCase())
        .join('')
        .substr(0, 2)
